export const styles = {
  buttonWrapper: (theme) => ({
    display: 'flex',
    justifyContent: 'flex-start',

    [theme.breakpoints.down('sm')]: {
      mt: 8,
      justifyContent: 'center',
    },
    zIndex: 2,
  }),

  aiCard: (theme) => ({
    position: 'relative',
    backgroundColor: 'kit.main',
    display: 'flex',
    padding: '24px 24px 16px 24px',
    flexDirection: 'column',
    borderRadius: '16px',

    [theme.breakpoints.down('sm')]: {},
  }),

  fireIcon: {
    right: '2px',
    top: '-18px',
    position: 'absolute',
  },

  logos: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
};
